import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'src/app/shared/services/angular-service/local-storage.service';
import { SeoService } from 'src/app/shared/services/angular-service/seo.service';
import { CompanyService } from 'src/app/shared/services/node-api/company.service';
@Component({
  selector: 'app-micro-product-page',
  templateUrl: './micro-product-page.component.html',
  styleUrls: ['./micro-product-page.component.scss'],
})
export class MicroProductPageComponent implements OnInit {
  industry_list:any
  totalRecords:any

  rowsPerPageOptions = ['24', '48', '72', '96'];
  paginationRequest = {
    field: 'published_date',
    order: -1,
    rows: 24,
    page: 0,
    filter: {},
    totalRecords: 0,
  };
  filter = false;

  public selectedFilters: any;
  public selectSortFilters: any
  public selectedSearch: string = '';
  public isSearching = true;
  deviceType;
  isFilterVisible = true;

  constructor(
    private companyService:CompanyService,
    private seoService: SeoService,
    private localStorageService: LocalStorageService,
  ) {
    this.deviceType = localStorageService.getItem('deviceType');
    if (this.deviceType === 'mobile') {
      this.isFilterVisible = false;
    }
  }

  ngOnInit(): void {
    this.getIndustryReport();
    this.seoService.getSeo('report');
  }

   getIndustryReport() {
    this.isSearching = true;
    let query = {
      field: this.paginationRequest.field,
      order: this.paginationRequest.order,
      rows: this.paginationRequest.rows,
      page: this.paginationRequest.page,
      filter: this.paginationRequest.filter,
      textSearch: this.selectedSearch,
    };

    this.companyService
      .getIndustryReport(query)
      .then((data) => {
        this.industry_list = data['data'];
        this.totalRecords=data['totalRecords'];
        // console.log(data)
      })
      .catch((err: any) => {
        console.log(err);
      });
  }

  selectedFilter(selectedFilters) {
    this.selectedFilters = selectedFilters;
    this.modifyFilter();
  }


  modifyFilter() {
    // console.log(this.selectedSearch);
    // console.log(this.selectedFilters);
    if (
      (this.selectedSearch !== undefined &&
        this.selectedSearch !== null &&
        this.selectedSearch !== '') ||
      (this.selectedFilters !== undefined &&
        this.selectedFilters?.category !== undefined &&
        this.selectedFilters.category !== null &&
        this.selectedFilters.category.length > 0) ||
      (this.selectedFilters?.subcategory !== undefined &&
        this.selectedFilters.subcategory !== null &&
        this.selectedFilters.subcategory.length > 0) ||
      (this.selectedFilters?.published_date !== undefined &&
        this.selectedFilters.published_date !== null &&
        this.selectedFilters.published_date.length > 0)||
      (this.selectedFilters?.status !== undefined &&
        this.selectedFilters.status !== null &&
        this.selectedFilters.status.length > 0)
    ) {
      this.paginationRequest.page = 0;
      this.industry_list = [];
      this.filter = true;
      this.paginationRequest.filter = {};
      if (this.selectedFilters) {
        Object.keys(this.selectedFilters).forEach((key: any) => {
          if (
            this.selectedFilters[key] &&
            this.selectedFilters[key].length > 0
          ) {
            this.paginationRequest.filter[key] = [];
            if (key == 'subcategory') {
              this.selectedFilters[key].forEach((value) => {
                this.paginationRequest.filter[key].push({
                  value: value,
                  matchMode: 'in',
                  operator: 'or',
                });
              });
            }  else if(key == 'category'){
              this.selectedFilters[key].forEach((value) => {
                this.paginationRequest.filter[key].push({
                  value: value,
                  matchMode: 'in',
                  operator: 'or',
                });
              });
            } else {
              this.selectedFilters[key].forEach((value) => {
                this.paginationRequest.filter[key].push({
                  value: value,
                  matchMode: 'gteD',
                  operator: 'or',
                });
              });
            }
          }
        });
      }
    } else {
      // if (this.filter) {
      this.paginationRequest.page = 0;
      this.industry_list = [];
      this.filter = false;
      this.paginationRequest.filter = {};
      // }
    }
    // console.log('Filters', JSON.stringify(this.paginationRequest.filter));
    this.getIndustryReport();
  }

  toggleFilterView() {
    this.isFilterVisible = !this.isFilterVisible;
  }
}
